import React from 'react'
import styled from 'styled-components'

type ValidationErrorProps = {
  errors: any[]
}

const ErrorList = styled.ul`
  margin: 10px 0 0 20px;
  padding: 0;
`

const ErrorItem = styled.li`
  margin: 5px 0;
  font-size: 14px;
`

const ErrorField = styled.strong`
  display: inline-block;
`

export const ValidationErrorDisplay: React.FC<ValidationErrorProps> = ({
  errors
}) => {
  if (!errors || errors.length === 0) return null

  return (
    <ErrorList>
      {errors.map((error, index) => {
        // Verificar se o erro é um objeto ou string
        if (typeof error === 'object' && error !== null) {
          // Se for um objeto, exibir as propriedades relevantes
          return (
            <ErrorItem key={index}>
              <ErrorField>{error.message || error.field || 'Erro'} </ErrorField>
              {error.detail || error.description || JSON.stringify(error)}
            </ErrorItem>
          )
        }
        // Se for uma string, exibir normalmente
        return <ErrorItem key={index}>{error}</ErrorItem>
      })}
    </ErrorList>
  )
}
